module.exports = __webpack_public_path__ + "static/media/solution-img4.9e71eae1.png";